import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { Review, ConversationType, ConversationSummaries } from '@marageti/z4-sdk/lib/travel';
import DetailView from './review-view';

const DetailContainer = () => {
  const { reviewId } = useParams();
  const apiClient = useApiClient();
  const navigate = useNavigate();
  const { data: review, isLoading, error } = useFetch<Review>(apiClient.reviewsClient.getReview, [reviewId], !!reviewId);
  const { data: conversationSummaries } = useFetch<ConversationSummaries>(apiClient.tripRequestsClient.getConversationSummaries, [review?.tripRequestId], !!review?.tripRequestId);

  const travelerToZicassoId = conversationSummaries
    ?.find((s) => s.conversationType === ConversationType.TravelerToZicasso)
    ?.conversationId;
  const toChat = review?.tripRequestId && travelerToZicassoId
    ? `/trip-requests/${review?.tripRequestId}/messages/${travelerToZicassoId}`
    : '#';

  const handleEdit = () => {
    navigate('./edit');
  };

  return (
    <DetailView
      review={review}
      loading={isLoading}
      error={error}
      onClickEdit={handleEdit}
      toChat={toChat}
    />
  );
};

export default DetailContainer;
